<app-loader *ngIf="dataLoading || changeStatusLoading"></app-loader>
<div *ngIf="!dataLoading">
  <div *ngIf="!changeStatusDataError">
    <form (ngSubmit)="onChangeEmployeeStatus()" #changeStatusForm="ngForm">
      <div class="modal__header">
        <span class="title">Изменение статуса сотрудника</span>
        <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appCloseXEmployeeChangeStatus"></div>
      </div>
      <div class="modal__body">
        <div class="mt-16">
          <div>
            <span class="title title--s">Сотрудник</span>
          </div>
          <div>
            {{ employee.employee.full_name }}
          </div>
        </div>
        <div class="mt-16">
          <app-field>
            <label>Статус</label>
            <app-select
              [items]="statusesFiltered"
              (callback)="onChangeEmployeeStatusType($event)"
              [textKey]="'sws_name'"
              [isDisabled]="isBlockedChangeStatus"
              [name]="'EmployeeStatusName'"
            ></app-select>
          </app-field>
        </div>
        <div class="mt-16">
          <app-field>
            <label>
              <span class="title title--s title--required">Дата и время</span>
            </label>
            <content-block>
              <div>
                <input type="hidden" id="ticketStatusDate" [ngModel]="statusTypeDate.dateObj && statusTypeDate.dateObj.dateMillis" (ngModelChange)="statusTypeDate.dateObj && (statusTypeDate.dateObj.dateMillis = $event)" name="statusDate" required />
                <app-date-time-picker
                  [initDate]="statusTypeDate.initDate"
                  [isShowTimepicker]="true"
                  [datepickerName]="'ticketStatusDateField'"
                  [options]="statusTypeDate.options"
                  (dateCallback)="onChangeStatusDate($event)"
                  [isDisabled]="isBlockedChangeStatus"
                ></app-date-time-picker>
              </div>
            </content-block>
          </app-field>
          <div class="mt-8" *ngIf="!statusTypeDate.isNewStatusDateInvalid && statusTypeDate.dateObj && statusTypeDate.dateObj.dateMillis">
            <app-message [type]="'warning'">
              <div message-content>{{ ticketStatusWarning }}</div>
            </app-message>
          </div>
        </div>
        <div class="mt-16" *ngIf="status === 3">
          <div class="mb-8">
            <span class="title title--s">Способ передвижения сотрудника на смене</span>
          </div>
          <div class="grid">
            <div class="grid__box grid__box--size-6 mb-8">
              <app-radio-button>
                <input
                  type="radio"
                  [disabled]="isBlockedChangeStatus"
                  (change)="onMethodTypeChanged('step')"
                  id="step"
                  name="methodType"
                  value="step"
                  [(ngModel)]="methodSelected"
                  required
                />
                <radio-button-text>Пешком</radio-button-text>
              </app-radio-button>
            </div>
            <div class="grid__box grid__box--size-6 mb-8">
              <app-radio-button>
                <input
                  type="radio"
                  [disabled]="isBlockedChangeStatus"
                  (change)="onMethodTypeChanged('auto')"
                  id="auto"
                  name="methodType"
                  value="auto"
                  [(ngModel)]="methodSelected"
                  required
                />
                <radio-button-text>На машине</radio-button-text>
              </app-radio-button>
            </div>
          </div>
        </div>
        <div class="mt-16">
          <a *ngIf="!isCommentShow" (click)="onChangeCommentVisible()" class="link link--dotted-gray-dark">Добавить комментарий</a>
          <div *ngIf="isCommentShow">
            <app-field>
              <label>
                <span class="title title--s">Комментарий</span>
              </label>
              <textarea [disabled]="isBlockedChangeStatus"
                        class="input-textarea"
                        rows="3"
                        [defaultValue]="commentary"
                        (change)="onCommentChange($event)"
                        id="appEmployeeChangeStatusComment">
              </textarea>
            </app-field>
          </div>
        </div>
        <div class="mt-16" *ngIf="errorMessage || changeStatusError">
          <app-message [type]="'error'">
            <div message-content>
              {{ errorMessage }}
              {{ changeStatusError }}
            </div>
          </app-message>
        </div>
      </div>
      <div class="modal__footer">
        <div class="modal__footer-action">
          <button
            class="button"
            type="button"
            (click)="onChangeEmployeeStatus()"
            id="appEmployeeChangeStatus"
            [disabled]="!changeStatusForm.form.valid || !statusTypeDate.isNewStatusDateInvalid || isBlockedChangeStatus"
          >
            Сохранить
          </button>
        </div>
        <div class="modal__footer-action">
          <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appCloseEmployeeChangeStatus"> Отмена </a>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="changeStatusDataError">
    <div class="mt-16">
      <app-message [type]="'error'">
        <div message-content>{{ changeStatusDataError }}</div>
      </app-message>
    </div>
  </div>
</div>
